<template>
  <div v-if="phone" class="wa-widget">
    <!-- Chat popup -->
    <transition name="wa-popup">
      <div v-if="open" class="wa-popup">
        <div class="wa-popup-header">
          <div class="wa-popup-header-info">
            <div class="wa-popup-avatar">
              <svg viewBox="0 0 175.216 175.552" xmlns="http://www.w3.org/2000/svg">
                <defs><linearGradient id="wa-g" x1="85.915" x2="86.535" y1="32.567" y2="137.092" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#57d163"/><stop offset="1" stop-color="#23b33a"/></linearGradient></defs>
                <path d="M87.184 25.227c-33.733 0-61.166 27.423-61.178 61.13a60.98 60.98 0 008.413 30.724l-8.942 32.644 33.467-8.773a61.14 61.14 0 0029.257 7.452h.026c33.72 0 61.163-27.431 61.17-61.14a60.81 60.81 0 00-17.895-43.251 60.77 60.77 0 00-43.27-17.929z" fill="url(#wa-g)"/>
                <path fill="#fff" fill-rule="evenodd" d="M68.772 55.603c-1.378-3.061-2.828-3.123-4.137-3.176l-3.524-.043c-1.226 0-3.218.46-4.902 2.3s-6.435 6.287-6.435 15.332 6.588 17.785 7.506 19.013 12.718 20.381 31.405 27.75c15.529 6.124 18.689 4.906 22.061 4.6s10.877-4.447 12.408-8.74 1.532-7.971 1.073-8.74-1.685-1.226-3.525-2.146-10.877-5.367-12.562-5.981-2.91-.919-4.137.921-4.746 5.979-5.819 7.206-2.144 1.381-3.984.462-7.76-2.861-14.784-9.124c-5.465-4.873-9.154-10.891-10.228-12.73s-.114-2.835.808-3.751c.825-.824 1.838-2.147 2.759-3.22s1.224-1.84 1.836-3.065.307-2.301-.153-3.22-4.032-10.011-5.666-13.647"/>
              </svg>
            </div>
            <div>
              <div class="wa-popup-name">{{ eventName || 'Suporte' }}</div>
              <div class="wa-popup-status">Online</div>
            </div>
          </div>
          <button class="wa-popup-close" @click="open = false">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
        </div>
        <div class="wa-popup-body">
          <div class="wa-popup-msg">
            <div class="wa-popup-msg-text">{{ greeting }}</div>
          </div>
        </div>
        <div class="wa-popup-footer">
          <a :href="waLink" target="_blank" rel="noopener noreferrer" class="wa-popup-cta">
            Chamar no WhatsApp
          </a>
        </div>
      </div>
    </transition>

    <!-- Floating button -->
    <button class="wa-float-btn" @click="open = !open" :class="{ active: open }">
      <svg v-if="!open" class="wa-icon" xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 16 16">
        <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
      </svg>
      <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'WhatsAppFloat',
  props: {
    phone: { type: [String, Number], default: null },
    eventName: { type: String, default: null },
    eventSlug: { type: String, default: null },
    message: { type: String, default: null }
  },
  data () {
    return { open: false }
  },
  computed: {
    greeting () {
      return this.message || 'Olá! Tem alguma dúvida sobre o evento? Clique no botão abaixo para falar conosco.'
    },
    waLink () {
      var base = 'https://wa.me/' + String(this.phone).replace(/\D/g, '')
      if (this.eventSlug) {
        var name = this.eventName || this.eventSlug
        var text = 'Ola! Gostaria de falar sobre o evento *' + name + '*.\n\n' +
          '_EVT_' + this.eventSlug + '_\n' +
          '⚠ Por favor, nao apague esta mensagem. Ela contem a identificacao do evento.'
        base += '?text=' + encodeURIComponent(text)
      }
      return base
    }
  }
}
</script>

<style scoped>
.wa-widget {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

/* Floating Button */
.wa-float-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: #25D366;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  animation: wa-bounce-in 0.4s ease-out;
}

.wa-float-btn:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.5);
}

.wa-float-btn .wa-icon {
  width: 34px;
  height: 34px;
}

/* Popup */
.wa-popup {
  width: 320px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
}

.wa-popup-header {
  background: #075E54;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wa-popup-header-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wa-popup-avatar {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.wa-popup-avatar svg {
  width: 40px;
  height: 40px;
}

.wa-popup-name {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.wa-popup-status {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
}

.wa-popup-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  padding: 4px;
  display: flex;
  transition: color 0.15s;
}

.wa-popup-close:hover {
  color: #fff;
}

/* Body */
.wa-popup-body {
  padding: 20px 16px;
  background: #E5DDD5;
  background-image: url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23d4cdc4' fill-opacity='0.15'%3E%3Cpath d='M0 0h40v40H0V0zm40 40h40v40H40V40z'/%3E%3C/g%3E%3C/svg%3E");
}

.wa-popup-msg {
  background: #fff;
  border-radius: 0 8px 8px 8px;
  padding: 10px 14px;
  max-width: 85%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.06);
  position: relative;
}

.wa-popup-msg::before {
  content: '';
  position: absolute;
  top: 0;
  left: -6px;
  width: 0;
  height: 0;
  border-top: 6px solid #fff;
  border-left: 6px solid transparent;
}

.wa-popup-msg-text {
  font-size: 13px;
  line-height: 1.5;
  color: #303030;
}

/* Footer / CTA */
.wa-popup-footer {
  padding: 12px 16px;
  background: #F0F0F0;
}

.wa-popup-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  background: #25D366;
  color: #fff;
  border-radius: 24px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.15s;
}

.wa-popup-cta:hover {
  background: #1fba59;
  color: #fff;
  text-decoration: none;
}

.wa-popup-cta svg {
  flex-shrink: 0;
}

/* Transition */
.wa-popup-enter-active {
  animation: wa-popup-in 0.25s ease-out;
}
.wa-popup-leave-active {
  animation: wa-popup-in 0.2s ease-in reverse;
}

@keyframes wa-popup-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes wa-bounce-in {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 640px) {
  .wa-widget {
    bottom: 16px;
    right: 16px;
  }

  .wa-float-btn {
    width: 52px;
    height: 52px;
  }

  .wa-float-btn .wa-icon {
    width: 30px;
    height: 30px;
  }

  .wa-popup {
    width: calc(100vw - 32px);
  }
}
</style>
